var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlaybackPlaySmall = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: 32,
  height: 32
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "playback-play-small_svg__a",
  width: 32,
  height: 32,
  x: 0,
  y: 0,
  rx: 4
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "playback-play-small_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#playback-play-small_svg__a"
})), /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#playback-play-small_svg__a",
  fill: "#484848",
  fillOpacity: 0.6
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#playback-play-small_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M10.426 9.538c0-1.195 1.046-1.93 1.87-1.317l8.678 6.462c.8.597.8 2.037 0 2.634l-8.677 6.462c-.825.613-1.871-.122-1.871-1.317z"
})))));
export default SvgPlaybackPlaySmall;